import React from 'react';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

function AISection() {
  const section = setup.aiCapabilities;
  if (!section) return null;

  return (
    <MotionSection id="ai" muted>
      <SectionHeader eyebrow="Intelligence" title={section.title} subtitle={section.subtitle} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {section.items.map((item, index) => (
          <div key={item.name} className="ui-card p-5" style={{ animationDelay: `${index * 50}ms` }}>
            <div className="w-9 h-9 rounded-lg border border-line bg-accent-muted flex items-center justify-center text-accent mb-3">
              <SmartToyOutlinedIcon sx={{ fontSize: 18 }} />
            </div>
            <h3 className="text-sm font-semibold text-ink mb-1.5">{item.name}</h3>
            <p className="text-sm text-ink-muted leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </MotionSection>
  );
}

export default AISection;
